// extracted by mini-css-extract-plugin
export default {"DataExtractionNavigationItems":"webpack-pages-DataExtraction-Navigation-DataExtractionNavigationItems-module__DataExtractionNavigationItems"};